// extracted by mini-css-extract-plugin
module.exports = {"section":"section__9u3_Q","title":"title__2pQVp","body":"body__2GT9i","withdrawal-label-wrapper":"withdrawal-label-wrapper__1ijDj"};